module.exports = __webpack_public_path__ + "static/media/no-results.b8e874ae.png";